"use client";

import { type AppLocale, DEFAULT_LOCALE } from "shared/Locale";
import { useAuth } from "src/lib/contexts/AuthContext";

/**
 * The portal's language: the one the signed-in person chose, else the browser's. `browserLocale`
 * is the `_authed` layout's loader data (src/server/functions/BrowserLocale.ts).
 */
export const resolvePortalLocale = (
  savedLocale: AppLocale | null | undefined,
  browserLocale: AppLocale | undefined,
): AppLocale => savedLocale ?? browserLocale ?? DEFAULT_LOCALE;

/**
 * The current page's language: the portal's on portal pages (`browserLocale` is set there), English
 * on the public site.
 */
export const useRoutePortalLocale = (browserLocale: AppLocale | undefined): AppLocale => {
  const savedLocale = useAuth()?.authState?.user?.locale;
  return browserLocale ? resolvePortalLocale(savedLocale, browserLocale) : DEFAULT_LOCALE;
};
